import { TransactionOutlined } from "@ant-design/icons";
import { PERMISSION } from "constants/permission";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";
const Investments = React.lazy(() =>
	lazyRetry(() => import("../features/investment")),
);

const InvestmentDetail = React.lazy(() =>
	lazyRetry(() => import("../features/investment/detail")),
);

const investmentRoutes = [
	{
		label: "Investments",
		path: APP_PATH.investments,
		key: "investments",
		icon: <TransactionOutlined />,
		component: <Investments />,
		permissions: [PERMISSION.INVESTMENT.LIST, PERMISSION.INVESTMENT.EDIT],
	},
	{
		label: "Investment detail",
		path: APP_PATH.investmentDetail,
		key: "investmentDetail",
		hidden: true,
		component: <InvestmentDetail />,
		permissions: [PERMISSION.INVESTMENT.EDIT],
	},
	{
		label: "Create investment",
		path: APP_PATH.investmentCreate,
		key: "investmentCreate",
		hidden: true,
		component: <InvestmentDetail />,
		permissions: [PERMISSION.INVESTMENT.EDIT],
	},
];

export default investmentRoutes;
